module.exports = __webpack_public_path__ + "videos/about-2016.7cede0c.mp4";